/**
 * Root Imports
*/

import { ApiRequest } from '~/util/Api';

/**
 * Exports
*/

/**
 * 
 */
export function LoginService(data) {
  const config = {
    method: 'POST',
    uri: '/api/v1/login',
    data: data,
    headers: {
      Authorization: undefined
    }
  };

  return ApiRequest(config);
}

/**
 * 
 */
export function RegisterService(data) {
  const config = {
    method: 'POST',
    uri: '/api/v1/register',
    data: data,
    headers: {
      Authorization: undefined
    }
  };

  return ApiRequest(config);
}

/**
 * 
 */
export function RefreshService({ token, tokenType }) {
  const config = {
    method: 'POST',
    uri: '/api/v1/refresh',
    headers: {
      Authorization: `${ tokenType } ${ token }`
    }
  };

  return ApiRequest(config);
}

/**
 * 
 */
export function ForgotPasswordService(data) {
  const config = {
    method: 'POST',
    uri: '/api/v1/forgot-password',
    data: data,
    headers: {
      Authorization: undefined
    }
  };

  return ApiRequest(config);
}